module.exports = __webpack_public_path__ + "logo.svg?2c5ae777996fbf3803900a38a6872d4e";


//////////////////
// WEBPACK FOOTER
// ./resource/icons/logo.svg
// module id = 87
// module chunks = 0